import { makeStyles } from '@material-ui/core';
import { porcelain, white } from '../../../abstracts/colours';

const useStyles = makeStyles({
  root: {
    outline: '0',
    position: 'fixed',
    maxWidth: 'calc(100% - 32px)',
    minWidth: '16px',
    maxHeight: 'calc(100% - 32px)',
    minHeight: '16px',
    overflowX: 'hidden',
    overflowY: 'auto',
    width: 'auto',
    border: `solid 2px ${porcelain}`,
    padding: '10px',
    borderRadius: '10px',
    boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    backgroundColor: white,
  },
});

export default useStyles;
